import { PublicPageTemplate } from "./PublicPageTemplate";

const SolutionImmobilierPage = () => (
  <PublicPageTemplate
    badge="Solution Immobilier"
    title="L'IA au service de l'"
    highlight="immobilier"
    description="Automatisez la prospection, la qualification des leads et la gestion de votre portefeuille immobilier avec Grafton IA."
  />
);
export default SolutionImmobilierPage;
